import React from 'react'
import styles from "./LoadingOverlay.module.css"
export default function LoadingOverlay({loadingText = "Loading"}: {loadingText:string}) {
  return (
    <div className={styles.loadingMask}>
      <span className={styles.loadingText}>{loadingText}</span>
      <div className={styles.loadingImage}></div>
      <div className={styles.loadingColor}></div>
    </div>
  )
}
